export const IPOH_ACCOUNT_ID = "68707e7e17b78bce728f2254";
export const IPOH_INDOOR_SALESMAN_ID = "694c19388476faeb063f7ddb";

export const MERGED_INVOICE_ACCOUNT_ID = "63429be7a4b0715d61b8955c";
export const HIDE_DELIVERY_ORDER_ACCOUNT_ID = IPOH_ACCOUNT_ID;

export const isUserOrPrincipleId = (user, accountId) => {
    if (!user) return false;
    const principleId = user.principle?._id ?? user.principle;
    return (
        String(user._id || "") === accountId ||
        String(principleId || "") === accountId
    );
};

export const isIpohAccountUser = (user) =>
    isUserOrPrincipleId(user, IPOH_ACCOUNT_ID);
